import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type AlertProps } from 'antd';
import { type AutomationDetailResponse } from 'automations/queries/getAutomationDetail';
import { type GetAutomationExecutionResponse } from 'automations/queries/getAutomationExecution';
import { type AutomationMode } from 'automations/types/automation';

export interface AutomationConfigState {
  automationId?: string;
  automationData?: AutomationDetailResponse['automationList']['automations'][number];
  mode?: AutomationMode;
  debug: boolean;
  reportPanelOpen: boolean;
  reportExecutionId?: string;
  automationReportData?: GetAutomationExecutionResponse['automationExecutions']['automationExecutions'][number];
  canvasAlert?: AlertProps;
}

const initialState: AutomationConfigState = {
  debug: false,
  reportPanelOpen: true,
};

const automationConfigSlice = createSlice({
  name: 'automationConfig',
  initialState,
  reducers: {
    setAutomationId: (state, action: PayloadAction<string>) => {
      state.automationId = action.payload;
    },

    setAutomationData: (state, action: PayloadAction<AutomationConfigState['automationData']>) => {
      state.automationData = action.payload;
    },

    setAutomationMode: (state, action: PayloadAction<AutomationMode>) => {
      state.mode = action.payload;
    },

    setDebug: (state, action: PayloadAction<boolean>) => {
      state.debug = action.payload;
    },

    setReportPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.reportPanelOpen = action.payload;
    },

    setReportExecutionId: (state, action: PayloadAction<string>) => {
      state.reportExecutionId = action.payload;
    },

    setAutomationReportData: (
      state,
      action: PayloadAction<GetAutomationExecutionResponse['automationExecutions']['automationExecutions'][number]>,
    ) => {
      state.automationReportData = action.payload;
    },

    setCanvasAlert: (state, action: PayloadAction<AlertProps | undefined>) => {
      state.canvasAlert = action.payload;
    },

    resetReducer: () => initialState,
  },
});

export const {
  resetReducer,
  setAutomationData,
  setAutomationId,
  setAutomationMode,
  setDebug,
  setReportPanelOpen,
  setReportExecutionId,
  setAutomationReportData,
  setCanvasAlert,
} = automationConfigSlice.actions;

export default automationConfigSlice.reducer;
